module.exports = __webpack_public_path__ + "img/impact-image.58549537.png";